
import { ChevronUpIcon } from '@heroicons/react/24/solid';
import { Accordion, AccordionBody, AccordionHeader, Typography } from '@material-tailwind/react';
import React, { useState } from 'react';


const Icon = ({id, open}) => (
  <ChevronUpIcon className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`} />
)

const ImgFAQ = [
  {
    id: 1,
    image : 'FAQ1.png'
  },
  {
    id: 2,
    image : 'FAQ2.png'
  },
  {
    id: 3,
    image : 'FAQ3.png'
  },
]


function WhyChooseFAQ() {
  const [open, setOpen] = useState(0);
  const [dataImg, setDataImg] = useState([]);

  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);

    const WhatImg = ImgFAQ.filter((item)=> item.id === value);
    setDataImg(WhatImg);
  }


  return (
    <div className='mb-20 px-7 md:px-11 bg-gray-300 py-10'>
      <Typography variant='h4' className='pb-5 text-center underline underline-offset-8'>Keraguan Saat Melamar Pekerjaan</Typography>
      <Typography variant='small' className='pb-5 md:pb-0 text-center'>
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nobis dicta blanditiis corporis error itaque voluptatum odit aliquam autem ea. Molestias, doloremque nobis similique repellat nisi eligendi voluptates? Doloremque consequuntur molestias unde cum modi illum quia accusantium earum. Odio laborum quod exercitationem deleniti esse dolore, quas neque adipisci aspernatur a odit.
      </Typography>
      <div className='md:row-span-full grid md:grid-cols-2'>
        <div className='grid content-center'>
            {/* FAQ Here */}
            <Accordion open={open === 1} icon={<Icon id={1} open={open} />}>
              <AccordionHeader onClick={() => handleOpen(1)}>Lorem ipsum dolor sit amet consectetur ?</AccordionHeader>
              <AccordionBody>
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Est natus dignissimos, fugit possimus reprehenderit, incidunt quasi necessitatibus nulla, sit molestias libero voluptate autem soluta ipsa et quaerat quibusdam consectetur ipsam quas. Ipsam repellat quaerat in.
                <div>
                  {
                    dataImg.map((item)=> 
                      <div className='md:hidden flex justify-center items-center' key={item.id}>
                        <img className='w-3/4' src={item.image} alt="" />
                      </div> )
                  }
                </div>
              </AccordionBody>
            </Accordion>

            <Accordion open={open === 2} icon={<Icon id={2} open={open} />}>
              <AccordionHeader onClick={() => handleOpen(2)}>Lorem ipsum dolor sit amet consectetur ?</AccordionHeader>
              <AccordionBody>
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Est natus dignissimos, fugit possimus reprehenderit, incidunt quasi necessitatibus nulla, sit molestias libero voluptate autem soluta ipsa et quaerat quibusdam consectetur ipsam quas. Ipsam repellat quaerat in.
                <div>
                  {
                    dataImg.map((item)=> 
                      <div className='md:hidden flex justify-center items-center' key={item.id}>
                        <img className='w-3/4' src={item.image} alt="" />
                      </div> )
                  }
                </div>
              </AccordionBody>
            </Accordion>

            <Accordion open={open === 3} icon={<Icon id={3} open={open} />}>
              <AccordionHeader onClick={() => handleOpen(3)}>Lorem ipsum dolor sit amet consectetur ?</AccordionHeader>
              <AccordionBody>
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Est natus dignissimos, fugit possimus reprehenderit, incidunt quasi necessitatibus nulla, sit molestias libero voluptate autem soluta ipsa et quaerat quibusdam consectetur ipsam quas. Ipsam repellat quaerat in.
                <div>
                  {
                    dataImg.map((item)=> 
                      <div className='md:hidden flex justify-center items-center' key={item.id}>
                        <img className='w-3/4' src={item.image} alt="" />
                      </div> )
                  }
                </div>
              </AccordionBody>
            </Accordion>
        </div>

        {dataImg.length === 0 ? (
          <div className='hidden md:flex justify-center items-center'>
            <img className='w-3/4' src={ImgFAQ[0].image} alt="" />
          </div>
        ) : (
          dataImg.map((item)=> 
              <div className='hidden md:flex justify-center items-center' key={item.id}>
                <img className='w-3/4' src={item.image} alt="" />
              </div> )
        )}

      </div>
    </div>
  )
}

export default WhyChooseFAQ